/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers').controller('MessagesPortalHistoryController', messagesPortalHistoryController)

  messagesPortalHistoryController.$inject = ['$rootScope', 'NotificationService', 'MessagesPortalHistoryService', 'ngTableParams', 'HistoryService', 'FoundationApi', '$sce', '$scope', '$location']

  function messagesPortalHistoryController ($rootScope, NotificationService, MessagesPortalHistoryService, ngTableParams, HistoryService, FoundationApi, $sce, $scope, $location) {
    const vm = this

    // constants
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    }
    vm.show = false
    const HTTP_NOT_FOUND = 404

    const dateSelected = (type, date) => {
      if (type === 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    const search = () => {
      if (validateFields()) {
        vm.contactsTable = new ngTableParams({
          page: 1,
          count: 25
        }, {
          getData: function ($defer, params) {
            vm.filters.page = params.url().page
            MessagesPortalHistoryService
              .getData(vm.filters)
              .$promise
              .then(function (data) {
                if (data.success) {
                  vm.show = true
                  $defer.resolve(data.page)
                  params.total(data.total)
                  vm.total = data.total
                  return true
                }
              })
              .catch(function ({ data, status }) {
                if (status === HTTP_NOT_FOUND) {
                  vm.show = false
                  vm.contactsTable = false
                  NotificationService.warningHandler(data, $rootScope.labels.noRegisters)
                  return false
                }
                NotificationService.errorHandler(data, $rootScope.labels.errorSearchCpf)
              })
            }
          })
      }
    }

    const showHistory = (historyId) => {
      vm.is_loading = true
        HistoryService
          .find({id: historyId})
          .$promise
          .then(function (data) {
            vm.selectedHistory = data.history
            vm.messages = data.messages
            vm.is_loading = false
            FoundationApi.publish('modalHistory', 'open');
        }).catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorViewHistory);
        });
    }

    const validateFields = () => {
      const toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      const fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate)
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        NotificationService.warningHandler('', $rootScope.labels.maxPeriod30Days)
        return false
      }
      if (!vm.filters.cpf || vm.filters.cpf == null) {
        NotificationService.warningHandler('', $rootScope.labels.requiredCpf)
        return false
      }
      return true
    }

    function validateHistoryMenuPermission (){
      if ($rootScope.company_metadata.allow && $rootScope.company_metadata['history_menu'] && $rootScope.company_metadata['history_menu'].branch == true && $rootScope.user_data.role != $rootScope.profiles.ROLE_ADMIN)  {
        if (
          ($rootScope.company_metadata['history_menu'].user_operator && $rootScope.profiles.ROLE_OPERATOR == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_manager && $rootScope.profiles.ROLE_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_promoter && $rootScope.profiles.ROLE_PROMOTER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_administrator && $rootScope.profiles.ROLE_MESSAGES_PORTAL_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['history_menu'].user_supervisor && $rootScope.profiles.ROLE_MESSAGES_PORTAL_SUPERVISOR == $rootScope.user_data.role)
        ) {
            return true;
          }
          $location.path("");
      }
      return true ;
    }
    validateHistoryMenuPermission()

    function getClass (message) {
      var messageClass = 'right';

      if (message.sent_by_operator == '0') {
        messageClass = 'left';
      }
      return messageClass;
    }

    function filterMessage (message) {
      const imageDefault = "'" + window.location.origin + baseUrl + '/assets/images/placeholder.jpg' + "'"

      if (!message) {
        return;
      }
      var matches = message.match(/\[image channel="(.+)" file="(.+)"\]/);
      if (matches) {
        var channel = matches[1];
        var file = matches[2];
        message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + baseUrl + '/channel_media/' + channel + '/' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[attachment config_id="(.+)" file="(.+)" name="(.+)"\]/);
      if (matches) {
        var id = matches[1];
        var file = matches[2];
        var name = matches[3];
        if (name.match(/^http/) != null) {
                	var swap = file;
                	file = name;
                	name = swap;
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[attachment config_id="(.+)" name="(.+)" file="(.+)"\]/);
      if (matches) {
        var id = matches[1];
        var name = matches[2];
        var file = matches[3];
        if (name.match(/^http/) != null) {
                	var swap = file;
                	file = name;
                	name = swap;
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>';
        message = $sce.trustAsHtml(message);
        return message;
      }
      var matches = message.match(/\[image provider="(.+)" key="(.+)" file="(.+)"(?: name="(.+)")?\]/);
      if (matches) {
        var provider = matches[1];
        var key = matches[2];
        var file = matches[3];
        if (provider == 's3') {
          message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
          message = $sce.trustAsHtml(message);
          return message;
        }
      }
      var matches = message.match(/\[media type="(.+)" provider="(.+)" key="(.+)" file="(.+?)"(?: name="(.+)")?\]/);
      if (matches) {
        var type = matches[1];
        var provider = matches[2];
        var key = matches[3];
        var file = matches[4];
        filename = matches.length === 6 ? matches[5] : '';
        if (provider == 's3') {
          if (type == 'image') {
            message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.viewImage(this.src)"/>';
          } else if (type == 'video') {
            message = '<br><video controls="" src="' + file + '"></video>';
          } else if (type == 'audio') {
            			message = '<br><audio controls="" src="' + file + '"></audio>';
          			} else if (type == 'document') {
            			message = '<br><a href="' + file + '" target="_blank" >"' + $scope.labels.seeFile + ' ' + filename + '".</a>';
          			}
          message = $sce.trustAsHtml(message);
          return message;
        }
      }
      return message;
    }

    // functions
    vm.dateSelected = dateSelected
    vm.search = search
    vm.showHistory = showHistory
    vm.getClass = getClass
    vm.filterMessage = filterMessage;
  }
  // eslint-disable-next-line semi
})();
